// extracted by mini-css-extract-plugin
export var footer = "_s8-0";
export var inherit = "_s8-1";
export var input = "_s8-2";
export var modalContent = "_s8-3";
export var quillEditor = "_s8-4";
export var subtitle = "_s8-5";